const BASE = "https://static.prod-images.emergentagent.com/jobs/79bfca8c-32c6-4878-bd25-e5bcf3b04e5a/images";

export const IMG = {
  heroFeast: `${BASE}/718ebf566142a37236a742a972c3890a2bee07488d4696e7113cbaab2a7d40bc.jpeg`,
  biscuits: `${BASE}/ba02ac829c7da77d5548176f1bffb9536e1e8b98eb3f583e258044cb029ffa28.jpeg`,
  breakfast: `${BASE}/5133d80452ed772b7ba57356f1e156131a7807527f4b5c6cd2810870ffb4264b.jpeg`,
  burger: `${BASE}/cee71f26a750a3c4b7c05282184af1e41a7b27fcd992ea1339cbd6cbdf5cc163.jpeg`,
  cfs: `${BASE}/929c702a7a84735335fd1ef7c3335348f0a45c10557daafe0a0e562b11108489.jpeg`,
  dessert: `${BASE}/7fe3587016c900e787d3486726ebbcede420f0707828850915a87f29d800c29d.jpeg`,
  sides: `${BASE}/bd60e94433ca2d4756f0ad67221c6d2b24b4d4329314a2e7b3170f18278206ca.jpeg`,
  sandwich: `${BASE}/87ece577892c68e7a45b853c4a6bfb65bcf3122bcf59592691705ac3fb7ddf4e.jpeg`,
  interior: `${BASE}/b2d37998f1ed2b8e0da99414bc8acaaf3d90bcd8b5254a504fa7949579a4bed4.jpeg`,
  kitchen: `${BASE}/cd7caa681148b843c6eb0bf871a89bc7b33d9a242a874f29bcb462b71a9dceb2.jpeg`,
};

export const LOGO = "/hackberry-logo-white.png";

export const ADDRESS = {
  name: "Hackberry Home",
  line1: "11739 FM 773",
  cityStateZip: "Ben Wheeler, TX 75754",
  mapsQuery: "11739+FM+773,+Ben+Wheeler,+TX+75754",
};
